import { Injectable } from '@angular/core';
import { TranslationFromJsonService } from '@shared/feature/translate';
import { ErrorCodesService } from '@shared/ui/inputs';
import { ErrorCodes } from '../models/error-codes.models';

@Injectable({
  providedIn: 'root',
})
export class FormsErrorCodesService extends ErrorCodesService {
  constructor(private translate: TranslationFromJsonService, private errorCodes: ErrorCodes) {
    super();
  }
  getError(validation: string, fieldName: string): string {
    if (this.errorCodes.errorCodes[fieldName] && this.errorCodes.errorCodes[fieldName][validation]) {
      return this.translate.instant(this.errorCodes.errorCodes[fieldName][validation]);
    }

    return this.translate.instant(this.errorCodes.errorCodes['default'][validation]);
  }
}
